module.exports = __webpack_public_path__ + "/images/ico-color-hucha-money.be1693b.svg";